const menuBtn = document.querySelector('.header__open-btn')
const menu = document.querySelector('.header__col--menu')
const blocks = document.querySelectorAll('.block')

function setTop() {
    document.documentElement.style.setProperty('--hh', `${header.offsetHeight - 1}px`)
}

function handleMenuBtn() {
    menuBtn.addEventListener('click', () => {
        menuBtn.classList.toggle('active')
        menu.classList.toggle('active')
        setTop()
    })
}

function _initBlock(block) {
    const openBtn = block.querySelector('.block__open-btn')
    if (!openBtn) return

    // OPEN
    openBtn.addEventListener('click', () => {
        const activeBlock = document.querySelector('.block.active')
        if (activeBlock === block) return

        activeBlock?.classList.remove('active')
        block.classList.add('active')
        block.querySelector('.block__description').scrollTo({ top: 0 })
    })

    // CLOSE
    const closeBtn = block.querySelector('.block__close-btn')
    closeBtn?.addEventListener('click', () => block.classList.remove('active'))

    if (window.matchMedia('(hover: hover)').matches) {
        // Hover desktop
        openBtn.addEventListener(
            'mouseenter',
            () => {
                if (!block.querySelector('.block__figure--hover') || block.classList.contains('active')) return
                block.classList.add('hover')
            },
            { passive: true }
        )

        openBtn.addEventListener(
            'mouseleave',
            () => {
                block.classList.remove('hover')
            },
            { passive: true }
        )
    } else {
        // Hover mobile
        openBtn.addEventListener(
            'touchstart',
            () => {
                if (!block.querySelector('.block__figure--hover') || block.classList.contains('active')) return
                block.classList.add('hover')
            },
            { passive: true }
        )

        openBtn.addEventListener(
            'touchend',
            () => {
                block.classList.remove('hover')
            },
            { passive: true }
        )
    }
}

function initBlock(block) {
    const openBtn = block.querySelector('.block__open-btn')
    if (!openBtn) return

    const closeBtn = block.querySelector('.block__close-btn')

    // OPEN (click immédiat)
    openBtn.addEventListener('click', () => {
        const activeBlock = document.querySelector('.block.active')
        if (activeBlock === block) return

        activeBlock?.classList.remove('active')
        block.classList.add('active')
        block.querySelector('.block__content').scrollTo({ top: 0 })
    })

    // CLOSE
    closeBtn?.addEventListener('click', () => block.classList.remove('active'))

    // Desktop hover
    if (window.matchMedia('(hover: hover)').matches) {
        openBtn.addEventListener(
            'mouseenter',
            () => {
                if (!block.querySelector('.block__figure--hover') || block.classList.contains('active')) return
                block.classList.add('hover')
            },
            { passive: true }
        )

        openBtn.addEventListener(
            'mouseleave',
            () => {
                block.classList.remove('hover')
            },
            { passive: true }
        )
    }

    // Mobile hover (ne bloque pas le click)
    else {
        let touchMoved = false

        openBtn.addEventListener(
            'touchstart',
            () => {
                touchMoved = false
            },
            { passive: true }
        )

        openBtn.addEventListener(
            'touchmove',
            () => {
                touchMoved = true
            },
            { passive: true }
        )

        openBtn.addEventListener(
            'touchend',
            () => {
                if (touchMoved) {
                    // Swipe ou scroll léger → hover temporaire
                    if (!block.classList.contains('active') && block.querySelector('.block__figure--hover')) {
                        block.classList.add('hover')
                        setTimeout(() => block.classList.remove('hover'), 250)
                    }
                }
                // Sinon tap = click natif, rien à faire
            },
            { passive: true }
        )
    }
}

function setMissingBlocks() {
    document.querySelectorAll('.block--filler')?.forEach(block => block.remove())

    if (!window.matchMedia('(min-width: 896px)').matches) return

    let availableWidth = window.innerWidth,
        availableHeight = window.innerHeight - document.querySelector('#header').clientHeight,
        blocks = document.querySelectorAll('.block')

    let blocksCount = blocks.length

    let blocksPerColumn = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--cols')),
        blockHeight = availableWidth / blocksPerColumn,
        rowRemainder = blocksCount % blocksPerColumn,
        rowsCount = Math.ceil(blocksCount / blocksPerColumn),
        missingBlocks = rowRemainder === 0 ? 0 : blocksPerColumn - rowRemainder,
        missingRows = Math.ceil(availableHeight / blockHeight) - rowsCount

    if (!blocksCount) {
        missingBlocks = 0
        return
    }

    missingBlocks = missingRows >= 1 ? missingBlocks + missingRows * blocksPerColumn : missingBlocks

    const main = document.querySelector('.main')
    const blockEl = document.createElement('div')
    blockEl.className = 'block block--filler'

    for (let i = 0; i < missingBlocks; i++) {
        main.appendChild(blockEl.cloneNode(true))
    }
}

function handleResize() {
    setTop()
    setMissingBlocks()
    if (window.matchMedia('(min-width: 896px)').matches) {
        menuBtn.classList.remove('active')
        menu.classList.remove('active')
    }
}

setTop()
setMissingBlocks()
handleMenuBtn()
window.addEventListener('resize', () => handleResize())
blocks.forEach(initBlock)
